import { Modal } from 'glints-aries/lib/@next';
import styled from 'styled-components';

export const LeaveGlintsConfirmationContainer = styled(Modal)`
  max-width: 620px;
  width: 100%;

  .modal-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
